import clsx from "clsx"
import { AudioCard } from "../AudioCard"
import { TextCard } from "../TextCard"
import styles from "./TextAudioCard.module.scss"

export function TextAudioCard({ sourceAudio, sourceText, isSelected, isCorrect, className}) {
    return (
        <div className={clsx(styles.textAudioContainer, className)} >
            <div className={styles.textController}>
                <TextCard sourceText={sourceText}/>
            </div>
            <AudioCard sourceAudio={sourceAudio} className={styles.audioController} isSelected={isSelected} isCorrect={isCorrect}/>
        </div>
    )
}